// Mobile drawer / search modal in sections/header.liquid.
// Openers:  [data-header-panel-open="<panel id>"]
// Closers:  [data-header-panel-close="<panel id>"] (close buttons, and the overlay <div>)
if (!customElements.get('header-panel')) {
  customElements.define(
    'header-panel',
    class HeaderPanel extends HTMLElement {
      connectedCallback() {
        this.onKeyDown = (event) => {
          if (event.key === 'Escape') this.close();
        };
        document.addEventListener('keydown', this.onKeyDown);

        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-submenu-toggle]');
          if (toggle) this.toggleSubmenu(toggle);
        });
        this.addEventListener('keydown', (event) => {
          const toggle = event.target.closest('[data-submenu-toggle]');
          if (toggle && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            this.toggleSubmenu(toggle);
          }
        });
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeyDown);
        if (this.isOpen) HeaderPanel.setScrollLock(false);
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      get overlay() {
        return document.querySelector(`div[data-header-panel-close="${this.id}"]`);
      }

      open(opener = document.activeElement) {
        if (this.isOpen) return;
        this.opener = opener;
        this.inert = false;
        this.setAttribute('aria-hidden', 'false');
        this.classList.add('is-open');
        this.overlay?.classList.add('is-open');
        this.setOpenerState(true);
        HeaderPanel.setScrollLock(true);

        const focusTarget = this.querySelector(this.dataset.focusTarget) || this;
        setTimeout(() => trapFocus(this, focusTarget), parseInt(this.dataset.focusDelay) || 0);
      }

      close() {
        if (!this.isOpen) return;
        this.classList.remove('is-open');
        this.overlay?.classList.remove('is-open');
        removeTrapFocus(this.opener || null);
        this.inert = true;
        this.setAttribute('aria-hidden', 'true');
        this.setOpenerState(false);
        HeaderPanel.setScrollLock(false);
      }

      setOpenerState(open) {
        document
          .querySelectorAll(`[data-header-panel-open="${this.id}"]`)
          .forEach((button) => button.setAttribute('aria-expanded', String(open)));
      }

      toggleSubmenu(toggle) {
        const item = toggle.closest('.mobile-drawer-nav-item');
        if (!item) return;
        const open = item.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      }

      static setScrollLock(locked) {
        document.documentElement.classList.toggle('overflow-hidden', locked);
        document.body.classList.toggle('overflow-hidden', locked);
      }
    }
  );

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-header-panel-open]');
    if (opener) {
      document.getElementById(opener.dataset.headerPanelOpen)?.open(opener);
      return;
    }
    const closer = event.target.closest('[data-header-panel-close]');
    if (closer) document.getElementById(closer.dataset.headerPanelClose)?.close();
  });

  // Backwards-compatible globals (previously defined inline in header.liquid)
  window.openMobileDrawer = () => document.getElementById('mobile-drawer')?.open();
  window.closeMobileDrawer = () => document.getElementById('mobile-drawer')?.close();
  window.openMobileSearch = () => document.getElementById('mobile-search-modal')?.open();
  window.closeMobileSearch = () => document.getElementById('mobile-search-modal')?.close();
}
